import cn from 'classnames';
import { IMetrics, IPhrase, tGameType } from 'common/modules/ReactShared';
import { FC } from 'react';
import { PADDINGABLE_FOR_MOBILE_STATUS_BAR_CLASS } from 'students/constants';
import { useTypedSelector } from 'students/stores/_utils';
import userSelectors from 'students/stores/user/selectors';
import styled from 'styled-components';
import useTaskGames from './useTaskGames';

export interface IWordGamesProps {
  lessonId: number;
  taskId: number;
  silentMode?: boolean;
  phrases: IPhrase[];
  gameType: tGameType;
  onGameComplete: () => void;
  onRoundComplete: (metrics: IMetrics) => void;
}

const TaskGames: FC<IWordGamesProps> = ({
  lessonId,
  taskId,
  silentMode,
  phrases,
  gameType,
  onGameComplete,
  onRoundComplete
}) => {
  const userProfile = useTypedSelector(userSelectors.selectProfile);
  const { game, gameplay, metrics } = useTaskGames({
    silentMode,
    lessonId,
    phrases,
    gameType,
    onGameComplete
  });
  const ActiveGame = game?.component;
  const gameConfig = game?.config;

  const handleOnNext = () => {
    onRoundComplete(metrics);

    gameplay.nextGame();
  };

  return (
    <SGameWrapper>
      {ActiveGame && (
        <ActiveGame
          taskId={taskId}
          showTutorial={gameConfig?.showTutorial}
          difficulty={gameConfig?.difficulty}
          maxRounds={gameConfig?.maxRounds}
          disableCountdown={userProfile?.disableCountdown}
          phrases={phrases}
          onNext={handleOnNext}
          metrics={metrics}
          onRoundComplete={gameplay.roundComplete}
          className={cn(PADDINGABLE_FOR_MOBILE_STATUS_BAR_CLASS)}
        />
      )}
    </SGameWrapper>
  );
};

export default TaskGames;

const SGameWrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
`;
